import { Editor, Operation } from 'slate';

import { BuiltInComponents, TypographyVariants } from 'craft/constants';
import { getBoundaries } from 'craft/rte/utils/getBoundaries';

// TODO type properties
const addVariantToProperties = (properties: any) => ({
  ...properties,
  data: { ...(properties.data || {}), variant: TypographyVariants.P },
});

type PropertyKey = 'properties' | 'newProperties';
const setCorrectProperty = (operation: Operation, propertiesKey: PropertyKey) => {
  // @ts-expect-error
  const properties = operation[propertiesKey];
  if (!properties || properties.type !== BuiltInComponents.Typography) {
    return operation;
  }
  const { data } = properties;
  if (data && data.variant) {
    return operation;
  }
  return { ...operation, [propertiesKey]: addVariantToProperties(properties) };
};

export const withTypography = <T extends Editor>(editor: T) => {
  const { apply, insertText } = editor;

  // eslint-disable-next-line no-param-reassign
  editor.apply = (operation) => {
    switch (operation.type) {
      case 'insert_node':
        return apply(setCorrectProperty(operation, 'properties'));

      case 'set_node':
        return apply(setCorrectProperty(operation, 'newProperties'));

      default:
        return apply(operation);
    }
  };

  // eslint-disable-next-line no-param-reassign
  editor.insertText = (text) => {
    const boundaries = getBoundaries(editor);

    if (boundaries.length === 1) {
      // eslint-disable-next-line no-param-reassign, prefer-destructuring
      editor.selection = boundaries[0];
    }

    insertText(text);
  };

  return editor;
};
